module.exports = __webpack_public_path__ + "static/media/iphone.2591875a.png";